import { motion } from "framer-motion";

const AREAS = [
  "Repetitive tasks",
  "Writing and communication",
  "Research",
  "Data analysis",
  "Documentation",
  "Administrative processes",
  "Customer service",
  "Internal workflows",
];

export default function OpportunityLab() {
  return (
    <section id="lab" data-testid="opportunity-lab-section" className="py-32 lg:py-40 bg-muted/60">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 grid grid-cols-1 lg:grid-cols-12 gap-16">
        <div className="lg:col-span-6">
          <motion.p initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.6, ease: "easeOut" }} className="text-xs md:text-sm tracking-[0.25em] uppercase font-bold text-accent">
            Beyond Training
          </motion.p>
          <motion.h2 initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.6, delay: 0.1, ease: "easeOut" }} className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-none mt-6">
            Turn the workshop into <span className="italic text-primary">organizational intelligence.</span>
          </motion.h2>
          <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.6, delay: 0.15, ease: "easeOut" }} className="mt-8 space-y-6 text-base sm:text-lg leading-relaxed font-light text-foreground/80 max-w-xl">
            <p>
              During selected engagements, participants complete an{" "}
              <strong className="font-semibold text-foreground">AI Opportunity Scorecard</strong>{" "}
              identifying work that may benefit from AI or automation.
            </p>
            <p>
              Phillip can then help leadership identify the strongest opportunities
              for continued AI adoption.
            </p>
            <p className="font-display text-xl sm:text-2xl text-foreground font-medium">
              This transforms professional development into the beginning of a technology strategy.
            </p>
          </motion.div>
        </div>
        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, delay: 0.1, ease: "easeOut" }}
          className="lg:col-span-5 lg:col-start-8 self-center"
        >
          <p className="text-xs tracking-[0.25em] uppercase font-bold text-foreground/50 mb-8">They examine:</p>
          <div className="flex flex-wrap gap-3" data-testid="opportunity-areas">
            {AREAS.map((a) => (
              <span key={a} className="rounded-full border border-[#D8D4CA] bg-background px-5 py-2.5 text-sm text-foreground/80">
                {a}
              </span>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
